export default __webpack_public_path__ + "images/0xc38464250F51123078BBd7eA574E185F6623d037.png";